
export class FranchiseLevel {
  franchiseLevelID: number;
  name: string;
  level: number;
};